// extracted by mini-css-extract-plugin
export default {"array":"arrayUI_array__hP6ZX","item":"arrayUI_item__Ih0CH","remove-box":"arrayUI_remove-box__F7bhx","error":"arrayUI_error__vMEZC"};